module.exports = __webpack_public_path__ + "static/ux_3_2_eg-17eb4d33bc8caee60792519b4f2bb7cf.png";